import { Component, computed, inject, signal } from '@angular/core';
import { form, FormField } from '@angular/forms/signals';
import { RouterLink } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SharedBillingUsageDialogComponent } from './shared-billing-usage-dialog/shared-billing-usage-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthenticationService } from '../authentication/authentication.service';
import { hasRole, Role } from '../shared/enums/role';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Theme, ThemeService } from '../core/theme.service';
import { PageWithNavigationComponent } from '../shared/page-templates/page-with-navigation/page-with-navigation.component';

@Component({
  selector: 'mce-settings',
  imports: [PageWithNavigationComponent, FormField, MatCardModule, MatFormFieldModule, MatSelectModule, MatButtonModule, MatIconModule, RouterLink],
  templateUrl: './settings.component.html',
})
export class SettingsComponent {
  private readonly themeService = inject(ThemeService);
  private readonly dialog = inject(MatDialog);
  private readonly authenticationService = inject(AuthenticationService);

  protected readonly sharedBillingMode = computed(() => {
    const roles = this.authenticationService.currentUserRoles();
    if (hasRole(roles, Role.SharedBillingMember)) return 'member';
    return hasRole(roles, Role.ProTier) ? 'owner' : 'locked';
  });

  protected readonly settingsModel = signal({ theme: this.themeService.currentTheme() });
  protected readonly settingsForm = form(this.settingsModel);

  protected setTheme(theme: Theme): void {
    this.themeService.setTheme(theme);
  }

  protected viewSharedBillingUsage(): void {
    if (this.sharedBillingMode() !== 'owner') return;
    this.dialog.open(SharedBillingUsageDialogComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      ariaLabel: 'Shared billing usage',
    });
  }
}
